import { clsx } from 'clsx';

export type LineSkeletonProps = {
  variant?: keyof typeof variantHeights;
  cols?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  className?: string;
};
const variantHeights = {
  caption: 'h-3',
  body: 'h-4',
  h2: 'h-5',
  h4: 'h-4',
  h1: 'h-7 lg:h-9',
};

export const LineSkeleton = ({
  variant = 'body',
  cols = 12,
  className,
}: LineSkeletonProps) => {
  const heightClasses = variantHeights[variant];
  return (
    <div
      className={clsx(
        gridColumns[cols],
        'bg-black-200 animate-pulse inline',
        heightClasses,
        className
      )}
    />
  );
};

const gridColumns = {
  1: 'col-span-1',
  2: 'col-span-2',
  3: 'col-span-3',
  4: 'col-span-4',
  5: 'col-span-5',
  6: 'col-span-6',
  7: 'col-span-7',
  8: 'col-span-8',
  9: 'col-span-9',
  10: 'col-span-10',
  11: 'col-span-11',
  12: 'col-span-12',
};
